import { render, staticRenderFns } from "./block-notifications-list-item.vue?vue&type=template&id=31b0936e&scoped=true&lang=pug&"
import script from "./block-notifications-list-item.vue?vue&type=script&lang=js&"
export * from "./block-notifications-list-item.vue?vue&type=script&lang=js&"
import style0 from "./block-notifications-list-item.vue?vue&type=style&index=0&id=31b0936e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b0936e",
  null
  
)

export default component.exports